import { gql } from 'apollo-boost';

export const UNPUBLISH_FOLDER = gql`
    mutation unpublishFolder($data: UnpublishFolderInput!) {
        unpublishFolder(data: $data)
    }
`;
